/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ModifyProfileRequestFromJSON(json) {
    return ModifyProfileRequestFromJSONTyped(json, false);
}
export function ModifyProfileRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'loginName': json['loginName'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'phone': json['phone'],
        'company': !exists(json, 'company') ? undefined : json['company'],
        'department': !exists(json, 'department') ? undefined : json['department'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'campus': !exists(json, 'campus') ? undefined : json['campus'],
        'building': !exists(json, 'building') ? undefined : json['building'],
        'floor': !exists(json, 'floor') ? undefined : json['floor'],
        'suite': !exists(json, 'suite') ? undefined : json['suite'],
    };
}
export function ModifyProfileRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'loginName': value.loginName,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'phone': value.phone,
        'company': value.company,
        'department': value.department,
        'propertyId': value.propertyId,
        'campus': value.campus,
        'building': value.building,
        'floor': value.floor,
        'suite': value.suite,
    };
}
